module.exports = __webpack_public_path__ + "static/img/guide03.136ab49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c23/guide03.png
// module id = 0zsp
// module chunks = 0